module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        return new Service({
            name: 'enrollmentReports',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/reports/v1/enrollments",
            cache: false,
            getReports: function(clientNumber) {
                this.url = this.url + "?clientNumber=" + clientNumber;
                return this.get();
            }
        });
    }]);
};
